import { Route, Routes } from "react-router-dom";

import { Balances,PayOuts,TopUps } from "../../pages";

export const BalancesLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<Balances/>} />
      <Route path="/payouts" element={<PayOuts/>} />
      <Route path="/top-ups" element={<TopUps/>} />
    </Routes>
  );
};
